__turbopack_context__.v({
  "body": "CollectionCardSmall-module__dE4-PG__body",
  "description": "CollectionCardSmall-module__dE4-PG__description",
  "icon": "CollectionCardSmall-module__dE4-PG__icon",
  "number": "CollectionCardSmall-module__dE4-PG__number",
  "rankAndIconContainer": "CollectionCardSmall-module__dE4-PG__rankAndIconContainer",
  "rankText": "CollectionCardSmall-module__dE4-PG__rankText",
  "root": "CollectionCardSmall-module__dE4-PG__root",
  "subtitle": "CollectionCardSmall-module__dE4-PG__subtitle",
  "title": "CollectionCardSmall-module__dE4-PG__title",
});
